document.addEventListener('DOMContentLoaded', function () {
    const productRecommendationsSection = document.querySelector('.product-recommendations');
    const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 1000px 0px' });

    observer.observe(productRecommendationsSection);

    function handleIntersection(entries, observer) {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(productRecommendationsSection);

        const url = productRecommendationsSection.dataset.url;

        fetch(url)
            .then(response => response.text())
            .then(text => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('.product-recommendations');

                if (recommendations) {
                    // Append the fetched recommendations to the product-recommendations section
                    productRecommendationsSection.innerHTML = recommendations.innerHTML;

                    // Now that the product data is available, initialize the Splide slider
                    initializeSplideSlider();
                }
            })
            .catch(e => {
                console.error(e);
            });
    }

    function initializeSplideSlider() {
        new Splide('#product-recommendations_slider', {
      
            fixedWidth: 320,
            perMove: 1,
            gap: '1rem',
            drag: 'free',
            snap: true,
            arrows: true,
            pagination: false,
            breakpoints: {
                768: {
                    fixedWidth: 200
                }
           
            }
        }).mount();
    }
});